import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule } from '@angular/forms';
import { PipeModuleModule } from 'src/app/pipe/pipe-module/pipe-module.module';
import { MatSortModule } from '@angular/material/sort';
import { ProductionReportsRoutingModule } from './production-reports-routing.module';
import { RptPrdJobHistoryComponent } from './rpt-prd-job-history/rpt-prd-job-history.component';
import { RptPrdProdWiseManufacturingComponent } from './rpt-prd-prod-wise-manufacturing/rpt-prd-prod-wise-manufacturing.component';
import { NgxSpinnerModule } from 'ngx-spinner';
// import { RptPrdProdWiseManufacturingComponent } from './rpt-prd-prod-wise-manufacturing/rpt-prd-prod-wise-manufacturing.component';



@NgModule({
  declarations: [
    RptPrdJobHistoryComponent,
    RptPrdProdWiseManufacturingComponent
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    FormsModule,
    ProductionReportsRoutingModule,
    PipeModuleModule,
    NgxSpinnerModule
  ]
})

export class ProductionReportsModule { }
